export const isTouchScreen = () => window.matchMedia('(hover: none)').matches;

export const isIpad = () => {
  if (/iPad/.test(window.navigator.platform)) {
    return true;
  } else {
    return !!(
      navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 2 &&
      /MacIntel/.test(navigator.platform)
    );
  }
};

export const isMultilineTextTrimmed = (
  element: HTMLElement | null,
  heightTolerance = 0,
) => {
  if (!element) return false;

  const elementClientHeight = element.clientHeight + heightTolerance;

  return (
    element.scrollHeight > elementClientHeight ||
    element.scrollWidth > element.clientWidth
  );
};
